import React from 'react';
import Pagination from './Pagination';
import { useSelector, useDispatch } from 'react-redux';
import { SET_GROUP_PAGINATION, SET_PAGINATION } from '../../redux/ActionName/ActionName';

function GroupPagination() {
    const dispatch = useDispatch();
    const GroupPaginationReducer = useSelector((state) => state.GropPaginationReducer);


    console.log("GroupPaginationReducer",GroupPaginationReducer);
    



    // Extract pagination data from reducer
    const { page, limit, total } = GroupPaginationReducer.pagination;

    // Handle page change
    const handlePageChange = (newPage) => {
        dispatch({
            type: SET_GROUP_PAGINATION,
            value: {
                ...GroupPaginationReducer.pagination,
                page: newPage
            }
        });
    };

    return (
        <div className="flex justify-center py-5">
            <Pagination
                total={total}
                outline={true}
                defaultCurrent={1}
                current={page}
                onChange={handlePageChange}
                pageSize={limit}
            />
        </div>
    );
}

export default GroupPagination;
